// extracted by mini-css-extract-plugin
module.exports = {"sideBarItem":"PhoneMenuItem_sideBarItem__2_zaA"};